/**
 * Centralized logging utility for frontend
 * 
 * In development: Logs to console with prefixes
 * In production: Only logs errors and warnings (no debug/info)
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const enableLogging = process.env.REACT_APP_ENABLE_LOGGING === 'true' || isDevelopment;

const logger = {
  /**
   * Debug logs - only in development
   */
  debug: (...args) => {
    if (enableLogging) {
      console.log('[DEBUG]', ...args);
    }
  },
  
  /**
   * Info logs - only in development
   */
  info: (...args) => {
    if (enableLogging) {
      console.info('[INFO]', ...args);
    }
  },
  
  /**
   * Warning logs - always logged (even in production)
   */
  warn: (...args) => {
    console.warn('[WARN]', ...args);
    // In production, you could send to error tracking service here
  },
  
  /**
   * Error logs - always logged (even in production)
   */
  error: (...args) => {
    console.error('[ERROR]', ...args);
    // In production, you could send to error tracking service here (e.g., Sentry)
  }
};

export default logger;

